
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>


<style>
html {
    -ms-text-size-adjust: none;
    -webkit-text-size-adjust: none;
    text-size-adjust: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
}

body {
    overflow-x: hidden;
    height: 100%;
    margin: 0 auto !important;
    font-size: 12px;
    background-color: transparent;
    -webkit-overflow-scrolling: touch;
    max-width: 640px;
    min-width: 300px;
    font-family: Microsoft YaHei, Arial;
    background:#f5f5f5
}

a {
    color: #222;
    text-decoration: none;
    background: 0 0;
    -webkit-tap-highlight-color: transparent
}

li,
ul {
    list-style: none outside none;
    padding: 0;
    margin: 0
}

img {
    vertical-align: middle;
    border: 0;
    width: 100%;
}

.clearfix {
    zoom: 1;
    clear: both
}



</style>



// WEBPACK FOOTER //
// App.vue?b4630844